import { DateField } from 'react-admin';

const DateFieldA = (props: any) => <DateField showTime {...props} />;

export default DateFieldA;
